import { CharacterSkins, CharacterSkinsValues } from '../CharacterSpine';
import { Player } from '../Player';
import ChunkBase from './ChunkBase';
import EntityContainer from './EntityContainer';
import { BodyTypes } from './LevelManager';
import { RunManager } from './RunManager';
import { app } from '../core/App';

export default class EntitySmashable extends EntityContainer {
  protected chunk: ChunkBase | undefined;
  protected isInitialised: boolean;
  protected hasCollided: boolean;
  protected allowedCharacter: CharacterSkinsValues;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);

    this.isInitialised = false;
    this.hasCollided = false;
    this.allowedCharacter = CharacterSkins.Grizzly;
  }

  protected static defaultIcon = 'icon-grizz.png';
  public static iconLookup: Map<CharacterSkinsValues, string> = new Map([
    [CharacterSkins.Grizzly, 'icon-grizz.png'],
    [CharacterSkins.Panda, 'icon-panda.png'],
    [CharacterSkins.Ice, 'icon-ice.png']
  ]);

  public init() {
    if (this.isInitialised) return;

    this.injectMatter(this);
    this.isInitialised = true;
  }

  public bindChunk(chunk: ChunkBase) {
    this.chunk = chunk;
  }

  // public reset() {
  //   this.alpha = 1;
  //   this.scale = 1;
  //   this.setVisible(true);
  //   this.setActive(true);

  //   this.hasCollided = false;
  // }

  public reset(allowedCharacter?: CharacterSkinsValues) {
    this.alpha = 1;
    this.scale = 1;
    this.setVisible(true);
    this.setActive(true);

    this.hasCollided = false;
    if (allowedCharacter) this.allowedCharacter = allowedCharacter;
    if (!this.allowedCharacter) this.allowedCharacter = CharacterSkins.Grizzly;
  }

  public recycle(removeFromChunk: boolean = false) {
    console.log('Recycling Smashable!');

    this.scene.tweens.killTweensOf(this);
    this.setVisible(false);
    this.setActive(false);
    this.setPosition(-1000, 0);

    if (removeFromChunk) this.chunk?.removeEntity(this);
    this.chunk = undefined;
  }

  protected injectMatter(target: Phaser.GameObjects.GameObject) {
    let x = this.x;
    let y = this.y;

    let matterSprite = this.scene.matter.add.gameObject(target, {
      label: BodyTypes.BreakableBlocker,
      isStatic: true,
      isSensor: true,
      onCollideCallback: this.onCollision.bind(this)
    }) as Phaser.Physics.Matter.Sprite;

    this.scene.matter.body.setPosition(target.body as MatterJS.BodyType, this.scene.matter.vector.create(x, y));
    this.scene.matter.setVelocity(target.body as MatterJS.BodyType, 0, 0);
  }

  protected onCollision(pair: MatterJS.IPair) {
    if (this.hasCollided) return;

    if ((pair.bodyA as MatterJS.BodyType).label == BodyTypes.Player && (pair.bodyA as MatterJS.BodyType).gameObject instanceof Player) {
      this.onCollisionWithPlayer(pair.bodyA as MatterJS.BodyType, (pair.bodyA as MatterJS.BodyType).gameObject);
    } else if ((pair.bodyB as MatterJS.BodyType).label == BodyTypes.Player && (pair.bodyB as MatterJS.BodyType).gameObject instanceof Player) {
      this.onCollisionWithPlayer(pair.bodyB as MatterJS.BodyType, (pair.bodyB as MatterJS.BodyType).gameObject);
    }
  }

  protected onCollisionWithPlayer(body: MatterJS.BodyType, player: Player) {
    this.hasCollided = true;

    if (body.gameObject.CurrentCharacter == this.allowedCharacter || player.CanBreakAllSmashables) {
      // Player breaks smashable.
      console.log('Smashing smashable!', player.CurrentCharacter, this.allowedCharacter);
      this.smashSelf();
      player.startSmash();
    } else {
      // Player dies on smashable.
      console.log('Smashable killing player!', player.CurrentCharacter, this.allowedCharacter);
      app.audioHandler.playSound(this.scene, 'SndDieBump', 'sfx');
      this.scene.events.emit(RunManager.events.PlayerDeath);
    }
  }

  protected smashSelf() {
    this.scene.add.tween({
      targets: this,
      // y: '+=-150',
      alpha: { from: 1, to: 0, duration: 250 },
      duration: 400,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.recycle,
      onCompleteParams: [true],
      onCompleteScope: this
    });

    let dustCloud = this.scene.add.spine(this.x, this.y + this.displayOriginX, 'dust-cloud', 'dust-cloud', false);
    dustCloud.on('end', () => {
      dustCloud.setActive(false);
      dustCloud.setVisible(false);
    });
    app.audioHandler.playSound(this.scene, 'SndCrateSmash', 'sfx');
  }
}
